import React from 'react';
import './signInLayout.scss';
import carePlan from '../assets/logo/cp.svg';


const SignInLayout = ({ children }) => {
  return (
    <div className="sign-in-layout">
      <main className="content">
        <div className="header">
          <img src={carePlan} alt="careplan logo" />
        </div>
        {children}
      </main>
  
    </div>
  );
};

export default SignInLayout;
